import { extractSiteGroupingProps } from '../utils';
import type { TrackingSite } from '../utils';
import { integrationStep } from './integration-step';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * Track the steps of the Optimizely integration.
 */
export const optimizelyIntegration = (step: string, site: TrackingSite): void => {
  integrationStep({
    name: 'Optimizely',
    step,
    groupData: extractSiteGroupingProps(site),
    data: {
      state_event_was_triggered_on: 'integration settings',
    },
  });
};
